<template>
  <UnSwitcherNew
    swKey="sw_range_length"
    :hasOpener="false"
  >
    <template #menu_after="v">
      <div class="bt-grey my-1"></div>
      <div
        class="gw_btn gw_btn_text z-index_0 gw_btn_small clr-grey text-small f-justify-start bt-grey"
        style="--padding: 0.5rem"
        @click="
          v.methods.toggleOpen(false),
            $store.dispatch('router_set_dialogs', 'range-length-switcher-help-dialog')
        "
      >
        <i class="mdi mdi-help-circle-outline mr-1 text-medium" />
        {{ $t('common.help') }}
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyRangeLengthSwitcher',
  components: {
    UnSwitcherNew,
  },
}
</script>

<style></style>
